//#region INTERFACE ISupplierDisableRule
export interface ISupplierDisableRule extends Object {
  descPrefix?: string;
  descSuffix?: string;
  onHoldCode?: number;
}

//#endregion

//#region INTERFACE ISupplierOnHandZeroDisableRule
export interface ISupplierOnHandZeroDisableRule extends ISupplierDisableRule, Object {
}

//#endregion

//#region INTERFACE ISupplierOnHandNotZeroDisableRule
export interface ISupplierOnHandNotZeroDisableRule extends ISupplierDisableRule, Object {
}

//#endregion

//#region INTERFACE IDisableSupplierRule
export interface IDisableSupplierRule extends Object {
  onHandNotZero?: ISupplierOnHandNotZeroDisableRule;
  onHandZero?: ISupplierOnHandZeroDisableRule;
}

//#endregion
